// extracted by mini-css-extract-plugin
export var boldText = "_68-4";
export var checkboxContainer = "_68-6";
export var closeIcon = "_68-i";
export var container = "_68-0";
export var drawer = "_68-8";
export var drawerContent = "_68-9";
export var extraSmallText = "_68-5";
export var fulfillmentGroupTable = "_68-e";
export var largeText = "_68-3";
export var loadingSpinnerContainer = "_68-j";
export var mediumText = "_68-2";
export var narrow = "_68-f";
export var notificationLink = "_68-l";
export var packageCheckIconContainer = "_68-7";
export var slideoutHeaderActions = "_68-g";
export var slideoutHeaderActionsShifted = "_68-h";
export var slideoutHeaderContainer = "_68-a";
export var slideoutModal = "_68-c";
export var stickyHeaderWrapper = "_68-b";
export var table = "_68-k";
export var tableContainer = "_68-d";
export var tertiaryText = "_68-1";